import React, { useEffect, useState,useRef,useContext } from 'react';
import { Link } from 'react-router-dom';
import HeaderBest from './header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Tracker() {

  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('');
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    toast.success('Email successfully subscribed!');
    setEmail('');
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return (
    <>
<>
<ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 9999,
          fontSize: '14px',
          width: 'auto',
          maxWidth: '400px'
        }}
      />
  {/*Preloader*/}
  <div id="preloader" style={{ display: "none" }}>
    <div className="tg-preloader-block">
      <div className="tg-spinner-eff">
        <div className="tg-bar tg-bar-top" />
        <div className="tg-bar tg-bar-right" />
        <div className="tg-bar tg-bar-bottom" />
        <div className="tg-bar tg-bar-left" />
      </div>
    </div>
  </div>
  {/*Preloader-end */}
  {/* Scroll-top */}
  <button className="scroll__top scroll-to-target open" data-target="html" onClick={scrollToTop}>
        <i className="fas fa-angle-up" />
      </button>
  {/* Scroll-top-end*/}
  {/* header-area */}
  <HeaderBest/>
  {/* header-area-end */}
  {/* main-area */}
  <section
      className="breadcrumb__area breadcrumb__bg"
      data-background="assets/img/bg/breadcrumb_bg.jpg"
      style={{ backgroundImage: 'url("assets/img/breadcrumb_bg.jpg")' }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb__content">
              <h1 className="title">Track Order</h1>
              <nav className="breadcrumb">
                <span property="itemListElement" typeof="ListItem">
                  <a href="/">Home</a>
                </span>
                <span className="breadcrumb-separator">
                  <i className="flaticon-right-arrow" />
                </span>
                <span property="itemListElement" typeof="ListItem">
                Track Order
                </span>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
  <main className="fix" style={{height:"80vh"}}>

    {/* tracking-area */}
    <section
  className="tracking__area"
  style={{
    height: 'calc(100vh - 80px)',
    position: 'relative',
    transform: 'scale(1.1)', // büyütme
    transformOrigin: 'center center' // büyüme merkezi (ortadan)
  }}
>
      <div className="tracking__content" style={{ 
        height: '100%',
        overflow: 'hidden',
        position: 'relative',
        marginTop: '-200px',
        height: '900px'
      }}>
       <iframe
  src="https://mitlog.com.tr/tracking/"
  style={{
    width: '100%',
    height: '1200px',
    border: 'none',
    overflow: 'hidden', // Bu sadece iframe kapsayıcısı için
    position: 'absolute',
    top: '-100px',
    left: 0,
    transform: 'scale(1)',
    transformOrigin: 'top left',
    scrollbarWidth: 'none' // Firefox için
  }}
  scrolling="no" // Eski tarayıcılar için destek
  title="Mitlog Tracking"
/>

      </div>
    </section>
    {/* tracking-area-end */}
  </main>
  {/* main-area-end */}
  {/* footer-area */}
  <footer className="footer__area fix">
        <div className="container">
          <div className="cta__wrap fix">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="cta__content">
                  <h3 className="title">
                    Fastest &amp; secure way to transport <br /> anything anytime
                  </h3>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta__btn text-end">
                <Link to="/getoffer" className="btn btn-two">
                    Request a Quote{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="cta__shape">
              <img
                src="/assets/img/cta_shape.png"
                alt="img"
                data-aos="fade-up-right"
                data-aos-delay={400}
                className="aos-init"
              />
            </div>
          </div>
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div className="footer__widget">
                  <div className="footer__logo">
                  <Link to="/">
                        <img src="/assets/img/mtllogo.png" alt="Logo" />
                      </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                    At MTL, we specialize in logistics solutions tailored to meet diverse delivery needs. 
                    </p>
                  </div>
                  <form onSubmit={handleSubscribe} className="footer__newsletter" style={{display: 'none'}}>
                    <div className="form-grp">
                      <input 
                        type="email" 
                        placeholder="enter your e-mail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </div>
                    <span>We don't send you any spam</span>
                  </form>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Our Services</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                      <Link to="/">Home</Link>
                      </li>
                      <li>
                      <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                      <Link to="/services">Services</Link>
                      </li>
                      <li>
                      <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                      <Link to="/getoffer">Get Offer</Link>
                      </li>
                      <li>
                      <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Other Logistics Companies</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                         <a href="https://mitlog.com.tr/">Mitlog Logistics</a>
                      </li>
                      <li>
                        <a href="https://www.mitlog-airsea.com.tr/">Mitlog Air&Sea Logistics</a>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Information</h4>
                  <div className="footer__info-wrap">
                    <ul className="list-wrap">
                      <li>
                        <i className="flaticon-location-1" />
                        <p>
                        8451 Market Street ste 138, <br /> Houston Texas 77029 , USA
                        </p>
                      </li>
                      <li>
                        <i className="flaticon-telephone" />
                        <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </li>
                      <li>
                        <i className="flaticon-time" />
                        <p>
                          Mon – Fri: 8.30- 17.30 EST
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copyright-text">
                  <p>
                    Copyright @MTL | All Right
                    Reserved
                  </p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer__social">
                  <ul className="list-wrap">
                  <li>
                        <a href="https://wa.me/18325621002" target="_blank">
                          <i className="fab fa-whatsapp" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                
                  
                      <li>
                        <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
              <li/>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__shape">
          <img
            src="/assets/img/footer_shape01.png"
            alt="shape"
            data-aos="fade-down"
            data-aos-delay={400}
            className="aos-init"
          />
          <img
            src="/assets/img/footer_shape02.png"
            alt="shape"
            data-aos="fade-left"
            data-aos-delay={400}
            className="aos-init"
          />
        </div>
      </footer>
  {/* footer-area-end */}
  {/* JS here */}
</>


    </>
  );
}

export default Tracker;

